import { render, staticRenderFns } from "./ScrollableTableRow.vue?vue&type=template&id=3ffbf70b&scoped=true&"
import script from "./ScrollableTableRow.vue?vue&type=script&lang=ts&"
export * from "./ScrollableTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffbf70b",
  null
  
)

export default component.exports